import React from "react";
import { Box, VStack, Heading, Text, Container } from "@chakra-ui/react";

function index() {
  return (
    <Container maxW="container.xl" mb={32} id="overview">
      <Box id="#overview">
        <VStack spacing={16}>
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            OVERVIEW
          </Heading>
          <Text
            fontSize="lg"
            fontWeight="500"
            lineHeight="49px"
            px={5}
            textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
          >
            Marbleverse is a high-risk, high-reward game of equal opportunity
            that offers players a chance to 2x-100x their investment in a matter
            of hours. Simple, fast, and transparent, it crowdsources funds and
            distributes them in a gamified way. <br />
            <br /> So, how does it work? Similar to poker or chess competitions,
            a PvP tournament is organized and a handsome prize fund generated
            from buy-ins. A series of elimination rounds is then held to
            determine the winner. Top 10-15% of players are rewarded with prizes
            ranging from 200% up to 10,000% of their initial capital. With a
            theoretical prize pool capped only by the number of participants,
            the winner of a massive tournament can become a millionaire in mere
            hours. <br /> <br />
            Our recipe for success: Games of equal chance + Crypto = Enormous
            untapped potential. Marbleverse's mission is to unlock this
            opportunity for everyone. To bootstrap the project, we are looking
            to build a community of enthusiasts that share our vision. All
            contributors of 0.04 ETH+ will receive a unique founding member
            Marbleverse NFT with extensive utility.
          </Text>
        </VStack>
      </Box>
    </Container>
  );
}
export default index;
